import React, { useState, useEffect, Suspense } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import TagsInput from 'react-tagsinput'
import { ReactSession } from 'react-client-session';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from '../../../Header/Header';
import Sidebar from '../../../Sidebar/Sidebar';
import Loader from '../../../Global/Loader';

import styles from '../../../../App.module.css';
import classes from './SoundCloud.module.css'
import Tabs from '../../Tabs/Tabs';
import TabsList from '../Tabs/Tabs';

import noThumb from "../../../../images/no-thumb.jpg";
const fileTypes = ["MP3"];

function AddMusic() {
    const navigate = useNavigate();
    const {register, handleSubmit, reset, formState: { errors }} = useForm();
    const [video, setVideo] = useState([]);
    const [image, setImage] = useState('');
    const [thumb, setThumb] = useState([]);
    const [vfile, setVfile] = useState(null);
    const [tags, setTags] = useState([]);
    const [ifDisabled, setIfDisabled] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState({
        status: false,
        type: '',
        message: ''
    });
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        !logged_user && navigate('/login');
    } , [])

    const getData = (vfile) => {
        setVfile(vfile);
    
        axios.post(`${process.env.REACT_APP_API_URL}/api/embed.php`, {
            "vfile": vfile,
            "media": 2
          }, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(response => {
            console.log(response.data);
            if(response.data.status === 'success') {
              setVideo(response.data.data);
            }else {
              toast.error(response.data.message);
            }
          })
    }

      useEffect(() => {
        setImage(video.thumbnail);
  
        video.tags && video.tags.map && video.tags.map(tag => {
            setTags(tags => [...tags, tag])
        })
  
        reset({
          'title': video.title,
          'description': video.description,
          'tags': tags.toString(),
          'duration': video.duration
        });
    }, [video])

    const onSubmit = (data) => {
        getData(data.vfile);
    }

    const changeSoundCloudThumb = (e) => {
        setThumb(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setImage(video.thumbnail);
        }
    }

    const handleChangeTags = (tags) => {
        setTags(tags);
    }

    const formSubmit = (e) => {
        setIfDisabled(true);

        const data = new FormData();
        data.append('user_id', logged_user);
        data.append('file', vfile);
        data.append('media', 2)
        data.append('title', video.title);
        data.append('description', video.description);
        data.append('tags', tags.toString());
        data.append('duration', video.duration || 0);
        data.append('nsfw', e.nsfw);
        data.append('privacy', e.priv);
        data.append('play-img', thumb);
        data.append('remote-img', video.thumbnail);

        // let formObject = Object.fromEntries(data.entries());
        // console.log(formObject);

        // const toast_id = toast.loading("Please wait...");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/share.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                setIsSubmitted({
                    status: true,
                    type: response.data.status,
                    message: response.data.message
                });

                setIfDisabled(false);
            }).catch(err => {
                console.log(err);
            })
    }

    return (
        <>
            <Header />
            <div className={styles.main_body}>
            <Suspense fallback="<div>Please wait...</div>">
                <Sidebar />
            </Suspense>
            <Suspense fallback="<div>Please wait...</div>">
                <div className={styles.main_content + ` main-content`}>
                    <div className={`${classes.addMusic_component} addMusic_component p-4`}>
                        <Tabs active="addmusic" />
                        <div className={classes.panel}>
                            <div className={classes.panel_body}>
                                <TabsList active="soundcloud" />
                                {
                                    video.length < 1 ? <div className="mt-4">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="form-group">
                                                <div className="form-control-wrap">
                                                    <label className={classes.floating_label}><i className="fa-solid fa-link"></i> &nbsp; Link to a SoundCloud user or track</label>
                                                </div>
                                                <div className="input-group">
                                                    <input {...register('vfile')} type="url" id="vfile" name="vfile" className={classes.input_area + ` form-control`} placeholder="https://" required />
                                                    <span className="input-group-btn">
                                                        <button className={classes.submit_btn + ` btn btn-primary`} type="submit">Embed</button>
                                                    </span>
                                                </div>
                                                {/* <em className="mt-2 d-block text-muted">Paste use a valid url like https://youtu.be/glri7uEYYTo or https://vimeo.com/98062343</em> */}
                                            </div>
                                        </form>
                                    </div>
                                    :   <>
                                            {
                                                !isSubmitted.status ? <form onSubmit={handleSubmit(formSubmit)}>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <div className="form-group">
                                                                <label>Title:</label>
                                                                <input {...register('title', {required: true})}  className="form-control" type="text" placeholder="Your Group's title" />
                                                                {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Description:</label>
                                                                <textarea {...register('description')} className="form-control" rows="3" placeholder="Your Group's Description"></textarea>
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Duration (in seconds):</label>
                                                                <input {...register('duration')}  className="form-control"  type="number" value="0" placeholder="Your Group's title" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Tags:</label>
                                                                <TagsInput value={tags} onChange={handleChangeTags} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Channel:</label>
                                                                <select {...register('categ')} className="form-control">
                                                                    <optgroup label="Categories" dangerouslySetInnerHTML={{__html: `${video.cats}`}} />
                                                                </select>
                                                            </div>
                                                            <div className="form-group">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <label>NSFW:</label>
                                                                        <div className={`form-group ${classes.radio}`}>
                                                                            <label className="radio d-inline-flex">
                                                                                <input {...register('nsfw')} type="radio" className="styled" value="1" /> <span>Not safe</span>
                                                                            </label>
                                                                            <label className="radio d-inline-flex">
                                                                                <input {...register('nsfw')} type="radio" className="styled" value="0" defaultChecked={true} /> <span>Safe</span>
                                                                            </label>
                                                                        </div>
                                                                        </div>
                                                                    <div className="col-6">
                                                                        <div className="form-group">
                                                                        <label>Privacy:</label>
                                                                        <div className={`form-group ${classes.radio}`}>
                                                                            <label className="radio d-inline-flex">
                                                                                <input {...register('priv')} type="radio" className="styled" value="1" /> <span>Private</span>
                                                                            </label>
                                                                            <label className="radio d-inline-flex">
                                                                                <input {...register('priv')} type="radio" className="styled" value="0" defaultChecked={true} /> <span>Public</span>
                                                                            </label>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`form-group mb-0 ${styles.btn_flex}`}>
                                                                <button className="btn btn-primary" type="submit" disabled={ifDisabled}>Save Song</button>
                                                                {
                                                                    ifDisabled && <Loader />
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-4">
                                                            <div className={`${classes.video_thumb} mt-4 mb-3`}>
                                                                <label htmlFor="">Thumbnail:</label>
                                                                <img src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Upload Thumbnails (350px X 250px):</label>
                                                                <input {...register('play-img')} onChange={changeSoundCloudThumb}  className="form-control" type="file" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                :   <div className='mt-4'>
                                                        <div class={`alert alert-${isSubmitted.type}`} role="alert">{isSubmitted.message}</div>
                                                        {
                                                            isSubmitted.type === 'success' && <div className="align-center" align="center">
                                                            <Link to="/dashboard/music" className="btn btn-primary">Manage media.</Link>
                                                            </div>
                                                        }
                                                    </div>
                                            }
                                        </>
                                    
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Suspense>
            </div>
        </>
    )
}

export default AddMusic